import { isExpired } from "@qubit/autoparts";
import dayjs from "dayjs";

import { useAppSelector } from "~/app/store";

import { checkIsExpiration, isExpirationValid } from "~/lib/helpers";
import { selectServerConfig } from "~/redux/selectors/appSelectors";
import {
  selectSelectedRow,
  inventoryDate
} from "~/redux/selectors/autostorePutawaySelectors";
import { PutAwayTaskSummaryDto } from "~/types/api";

const checkExpirationDate = (
  selectedRow: PutAwayTaskSummaryDto | undefined,
  invDate: string | Date | null,
  inv_inventoryDateRequired: boolean
) => {
  const isExpirationRequired = selectedRow?.product?.isExpirationRequired;
  const hasDateBeenRemoved = !invDate && !!selectedRow?.expirationDate;

  if (!isExpirationRequired && !invDate) {
    return !hasDateBeenRemoved;
  }

  const expirationDate = dayjs(invDate);
  const isInventoryExpired = isExpired(dayjs(), expirationDate);
  const isValid =
    !isInventoryExpired &&
    !!isExpirationValid(
      inv_inventoryDateRequired || isExpirationRequired,
      expirationDate
    );

  return isValid && !hasDateBeenRemoved;
};

const checkManufactureDate = (
  invDate: string | Date | null,
  inv_inventoryDateRequired: boolean
) => {
  return inv_inventoryDateRequired ? !!invDate : true;
};

export function useIsInventoryDateValid(
  putawayTasks: PutAwayTaskSummaryDto[]
): boolean {
  const { inv_inventoryDateLabel, inv_inventoryDateRequired } =
    useAppSelector(selectServerConfig);

  const selectedRow = useAppSelector((state) =>
    selectSelectedRow(state, putawayTasks)
  );
  const invDate = useAppSelector(inventoryDate);

  const isExpiration = checkIsExpiration(inv_inventoryDateLabel);

  if (isExpiration) {
    return checkExpirationDate(selectedRow, invDate, inv_inventoryDateRequired);
  } else {
    return checkManufactureDate(invDate, inv_inventoryDateRequired);
  }
}
